(function () {
  'use strict';

  var pageClass = 'collection-hub-page';
  var visibleClass = 'collection-products-in-view';
  var openClass = 'collection-filter-open';
  var observer = null;
  var panelObserver = null;
  var fallbackBound = false;
  var framePending = false;

  function collectionElement() {
    return document.querySelector('#Collection');
  }

  function filterButton() {
    return document.querySelector('#Collection #filter-button');
  }

  function filterPanel() {
    return document.querySelector('#cc-filter-panel');
  }

  function syncOpenState() {
    var root = document.documentElement;
    var panel = filterPanel();
    var button = filterButton();
    var isOpen = Boolean(panel && panel.classList.contains('active'));

    root.classList.toggle(openClass, isOpen);
    if (button) button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  }

  function closeFilter() {
    var panel = filterPanel();
    var button = filterButton();
    if (panel) panel.classList.remove('active');
    if (button) button.style.left = '0px';
    syncOpenState();
  }

  function setVisible(isVisible) {
    var root = document.documentElement;
    var button = filterButton();

    root.classList.toggle(visibleClass, isVisible);
    if (!button) return;

    if (isVisible) {
      button.removeAttribute('aria-hidden');
      if (button.dataset.collectionHubTabindex !== undefined) {
        var previousTabindex = button.dataset.collectionHubTabindex;
        if (previousTabindex) {
          button.setAttribute('tabindex', previousTabindex);
        } else {
          button.removeAttribute('tabindex');
        }
        delete button.dataset.collectionHubTabindex;
      }
      return;
    }

    if (button.dataset.collectionHubTabindex === undefined) {
      button.dataset.collectionHubTabindex = button.getAttribute('tabindex') || '';
    }
    button.setAttribute('aria-hidden', 'true');
    button.setAttribute('tabindex', '-1');
    closeFilter();
  }

  function updateFromGeometry() {
    framePending = false;
    var collection = collectionElement();
    if (!collection) {
      setVisible(false);
      return;
    }
    var rect = collection.getBoundingClientRect();
    setVisible(rect.top < window.innerHeight && rect.bottom > 0);
  }

  function requestGeometryUpdate() {
    if (framePending) return;
    framePending = true;
    window.requestAnimationFrame(updateFromGeometry);
  }

  function bindFallback() {
    if (fallbackBound) return;
    fallbackBound = true;
    window.addEventListener('scroll', requestGeometryUpdate, { passive: true });
    window.addEventListener('resize', requestGeometryUpdate);
  }

  function init() {
    if (!document.documentElement.classList.contains(pageClass)) return;

    var collection = collectionElement();
    if (!collection) {
      setVisible(false);
      return;
    }

    if (observer) observer.disconnect();
    if (panelObserver) panelObserver.disconnect();
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.target === collection) setVisible(entry.isIntersecting);
        });
      });
      observer.observe(collection);
    } else {
      bindFallback();
    }

    var panel = filterPanel();
    if (panel && 'MutationObserver' in window) {
      panelObserver = new MutationObserver(syncOpenState);
      panelObserver.observe(panel, { attributes: true, attributeFilter: ['class'] });
    }

    syncOpenState();
    updateFromGeometry();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
}());
